import useStore from "../store/store";
var useWeb3ReactModal = function () {
    var connect = useStore().connect;
    return { connect: connect };
};
export default useWeb3ReactModal;
